import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
	const business = useSelector(({ auth }) => auth.business);
	return business ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
